import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  FacetService,
  ProductListComponentService,
} from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { CustomProdPgService } from '../custom-prod-pg.service';

@Component({
    selector: 'app-custom-product-page',
    templateUrl: './custom-product-page.component.html',
    styleUrls: ['./custom-product-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomProductPageComponent implements OnInit, OnDestroy {
  public productList$ : any;
  pagination: any;
  currentPage = 1;
  facets$: any;
  pageRange: any;
  productLotSize: number | undefined;
  pagesize: number | undefined;
  userDetails: any;
  selectedData: any;
  prodListSub: Subscription | undefined;
  facetListSub: Subscription | undefined;
  usedDataSub: Subscription | undefined;
  constructor(
    private readonly productListService: ProductListComponentService,
    private readonly user: UserAccountFacade,
    private readonly plpService: CustomProdPgService,
    private readonly facet: FacetService,
    private cdr: ChangeDetectorRef
  ) {
    this.productList$ = this.productListService.model$;
  }

  ngOnInit(): void {
    this.prodListSub = this.productList$.subscribe((res) => {
      this.pagesize = res.pagination.pageSize;
      this.productLotSize = res.products.length;
      this.pagination = res.pagination;
      this.selectedData = res?.sorts?.find(
        (item) => item.code === 'relevance'
      ).name;
      this.performPagination(this.pagination.currentPage);
      this.cdr.detectChanges();
    });

    this.facetListSub = this.facet.facetList$.subscribe((res) => {
      this.facets$ = res.activeFacets;
      this.cdr.detectChanges();
    });
    this.usedDataSub = this.user.get().subscribe((res) => {
      this.userDetails = res;
      if (this.userDetails && this.userDetails !== null) {
        this.plpService.getCarts(this.userDetails?.userName);
      }
      this.cdr.detectChanges();
    });
  }
  sortList(event): void {
    this.productListService.sort(event);
  }
  performPagination(data): void {
    const event = Number(data);
    this.currentPage = event + 1;
    const firstRange = event * this.pagesize + 1;
    const secondRange = (event + 1) * this.pagesize;
    const previousValue = this.pagination.totalResults - event * this.pagesize;
    if (previousValue < this.pagesize) {
      this.pageRange = `${firstRange}-${previousValue + event * this.pagesize}`;
    } else {
      this.pageRange = `${firstRange}-${secondRange}`;
    }
  }
  ngOnDestroy() {
    this.prodListSub?.unsubscribe();
    this.facetListSub?.unsubscribe();
    this.usedDataSub?.unsubscribe();
  }
}
